const getAddress = (address) => {
  if (!address) {
    return void 0;
  }
  const {
    apartment,
    city,
    countryCode,
    salutation,
    firstName,
    lastName,
    streetName,
    streetNumber,
    additionalStreetInfo,
    postalCode,
    region,
    externalId,
    company
  } = address;
  return {
    city,
    countryCode,
    firstName,
    lastName,
    streetName,
    salutation: salutation ?? "",
    streetNumber: streetNumber ?? "",
    apartment: apartment ?? "",
    postalCode: postalCode ?? "",
    additionalStreetInfo: additionalStreetInfo ?? "",
    region: region ?? "",
    externalId: externalId ?? "",
    company: company ?? ""
  };
};
export {
  getAddress
};
//# sourceMappingURL=get-address.js.map
